export default {"src":"/_next/static/media/default-teacher.e472499a.svg","height":120,"width":120};